import { render } from "./ReferenceLinkingDemo.vue?vue&type=template&id=5a16352a&scoped=true"
import script from "./ReferenceLinkingDemo.vue?vue&type=script&lang=js"
export * from "./ReferenceLinkingDemo.vue?vue&type=script&lang=js"

import "./ReferenceLinkingDemo.vue?vue&type=style&index=0&id=5a16352a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a16352a"]])

export default __exports__